<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Region</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="dialog = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the name of the Region?</div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Region Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                v-model="latitude"
                hide-details
                dense
                outlined
                placeholder="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                v-model="longitude"
                hide-details
                dense
                outlined
                placeholder="Logitude"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    regionDetails: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dialog: false,
      name: "",
      latitude: "",
      longitude: "",
      id: "",
    };
  },
  computed: {
    changeFields() {
      return {
        name: this.name,
        latitude: this.latitude,
        longitude: this.longitude,
        id: this.id,
      };
    },
  },
  methods: {
    ...mapActions({
      updateRegion: "$_home/updateContent",
      getRegions: "$_home/getContent",
    }),
    toggleDialog(regionDetails) {
      this.dialog = !this.dialog;
      console.log("opening edit");
      if (this.dialog) {
        console.log(this.regionDetails);
        this.name = regionDetails.name;
        this.latitude = regionDetails.latitude;
        this.longitude = regionDetails.longitude;
        this.id = regionDetails.id;
      }
    },
    cancel() {
      this.dialog = false;
    },
    save() {
      console.log("Save region: ", this.changeFields);
      this.updateRegion({
        details: this.changeFields,
        collection: "regions",
        type: "Region",
      }).then(() => {
        this.dialog = false;
        this.getRegions({ collection: "regions", mutation: "updateRegions" });
      });
    },
  },
};
</script>

<style>
</style>